export default class UrlUtils {
    static substitute(url, substitutions) {
        if(!substitutions) {
            return url;
        }

        let urlResult = url;

        Object.keys(substitutions).forEach(key => {
            urlResult = urlResult.split(':' + key).join(substitutions[key]);
        });

        return urlResult;
    }

    static parametersToQueryString(parameters) {
        let encodedParameters = UrlUtils.encodeParameters(parameters);
        return Object.keys(encodedParameters).map(parameterKey => {
            const parameter = encodedParameters[parameterKey];
            if(Array.isArray(parameter)) {
                return parameter.map(p => `${parameterKey}=${p}`);
            }
            return `${parameterKey}=${parameter}`;
        }).flat().join('&');
    }

    static encodeParameters(parameters) {
        let encodedParameters = {};
        Object.keys(parameters).forEach(parameterKey => {
            const parameter = parameters[parameterKey];
            if(parameter && Array.isArray(parameter)) {
                encodedParameters[encodeURIComponent(parameterKey)] = parameter.map(value => encodeURIComponent(value));
            } else if (parameter && typeof parameter === 'object'){
                 encodedParameters[encodeURIComponent(parameterKey)] = encodeURIComponent(JSON.stringify(parameter));
            } else {
                encodedParameters[encodeURIComponent(parameterKey)] = encodeURIComponent(parameter);
            }
        });
        return encodedParameters;
    }

    static setQueryParameters(parameters) {
        let urlParts = window.location.href.split('?');
        let queryParameterString = UrlUtils.parametersToQueryString(parameters);

        if(queryParameterString) {
            window.history.replaceState({}, '', urlParts[0] + '?' + queryParameterString);
        } else {
            window.history.replaceState({}, '', urlParts[0]);
        }
    }

    static getQueryParameters(url) {
        if(!url) {
            url = window.location.href;
        }
        let urlParts = url.split('?');
        let parameterMap = {};

        if(urlParts.length > 1) {
            let parameters = url.slice(url.indexOf('?') + 1).split('&');
    
            parameters.forEach(parameter => {
                const [key, value] = parameter.split('=');
                if(key) {
                    const decodedValue = decodeURIComponent(value);
                    const decodedKey = decodeURIComponent(key);
                    if(parameterMap.hasOwnProperty(decodedKey)) {
                        if(Array.isArray(parameterMap[decodedKey])) {
                            parameterMap[decodedKey] = [...parameterMap[decodedKey], decodedValue];
                        } else {
                            parameterMap[decodedKey] = [parameterMap[decodedKey], decodedValue];
                        }
                    } else {
                        parameterMap[decodedKey] = decodedValue;
                    }
                }
            });
        }

        return parameterMap;
    }

	static getQueryParameter(key) {
        let url = window.location.href;
        let name = key.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return '';
        }

        let parameter = null;
        try {
            parameter = decodeURIComponent(results[2].replace(/\+/g, " "));
        } catch(e) {
            console.warn('Failed to get query parameter with key ' + key);
            console.warn(e);
        }

        return parameter;
    }
    
    static updateQueryParameters(parameters) {
        let currentParameters = UrlUtils.getQueryParameters();
        let updatedParameters = Object.assign({}, currentParameters, parameters);

        Object.keys(updatedParameters).forEach(parameterKey => {
            if(!updatedParameters[parameterKey] && parameters.hasOwnProperty(parameterKey)) {
                delete updatedParameters[parameterKey];
            }
        });

        UrlUtils.setQueryParameters(updatedParameters);
    }

    static updateQueryParameterByNestedKey(id, parameters){
        const currentParameters = UrlUtils.getQueryParameters();

        Object.keys(parameters).forEach((paramName) => {
          const paramValue = parameters[paramName];

          if (paramName in currentParameters) {
            let currVal  

            try {
              currVal = JSON.parse(currentParameters[paramName]);
            } catch (e) {
              // SyntaxError could occur when currentParameters.paramName is not JSON
              currVal = {};
            }

            if (!paramValue) delete currVal[id];
            else currVal[id] = paramValue;

            currentParameters[paramName] = currVal;
          } else if (paramValue) {
            currentParameters[paramName] = { [id]: paramValue };
          }

          if (currentParameters[paramName] && Object.keys(currentParameters[paramName]).length == 0) {
            delete currentParameters[paramName];
          }
        });

        UrlUtils.setQueryParameters(currentParameters);
    }

    static getHash() {
        return window.location.hash.substr(1);
    }

    static replaceDomain(url) {
        const confirmUrl = new URL(url);
        confirmUrl.protocol = window.location.protocol;
        confirmUrl.host = window.location.host;
        return confirmUrl.href;
    }

    static isStorefrontUrl(url){
        if(url?.indexOf('://') > 0 || url?.indexOf('//') === 0) {
            return url?.toLowerCase().indexOf(import.meta.env.VITE_STOREFRONT_BASE_URL) !== -1;
        } 
        else {
            return true;
        }
    }
}
